import React, { Component } from "react"
import { withStyles, createStyles } from "@material-ui/core"
import { connect } from "react-redux"
import { Cookies } from "react-cookie"
import clsx from "clsx"
import Drawer from "@material-ui/core/Drawer"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import CssBaseline from "@material-ui/core/CssBaseline"
import List from "@material-ui/core/List"
import Typography from "@material-ui/core/Typography"
import Divider from "@material-ui/core/Divider"
import IconButton from "@material-ui/core/IconButton"
import MenuIcon from "@material-ui/icons/Menu"
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import PeopleIcon from "@material-ui/icons/People"
import BusinessIcon from "@material-ui/icons/Business"
import BusinessTwoToneIcon from "@material-ui/icons/BusinessTwoTone"
import HomeIcon from "@material-ui/icons/Home"
import Button from "@material-ui/core/Button"
import Menu, { MenuProps } from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import PersonOutlineIcon from "@material-ui/icons/PersonOutline"
import LockOpenIcon from "@material-ui/icons/LockOpen"
import DescriptionIcon from "@material-ui/icons/Description"
import AccessibilityIcon from "@material-ui/icons/Accessibility"
import LocalHospitalIcon from "@material-ui/icons/LocalHospital"
import ListAltTwoToneIcon from "@material-ui/icons/ListAltTwoTone"
import PlaylistAddCheckTwoToneIcon from "@material-ui/icons/PlaylistAddCheckTwoTone"
import TextsmsTwoToneIcon from "@material-ui/icons/TextsmsTwoTone"
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered"
import TextureIcon from "@material-ui/icons/Texture"
import StarHalfTwoToneIcon from "@material-ui/icons/StarHalfTwoTone"
import WhatshotTwoToneIcon from "@material-ui/icons/WhatshotTwoTone"
import FlightLandTwoToneIcon from "@material-ui/icons/FlightLandTwoTone"
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn"
import PaymentIcon from "@material-ui/icons/Payment"
import AttachMoneyIcon from "@material-ui/icons/AttachMoney"
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck"
import DriveEtaIcon from "@material-ui/icons/DriveEta"
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn"
import AssessmentIcon from "@material-ui/icons/Assessment"
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline"
import AssignmentReturnIcon from "@material-ui/icons/AssignmentReturn"
import DirectionsCarIcon from "@material-ui/icons/DirectionsCar"
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted"
import ApartmentIcon from "@material-ui/icons/Apartment"
import SendIcon from "@material-ui/icons/Send"
import MoneyOffIcon from "@material-ui/icons/MoneyOff"
import BugReportIcon from "@material-ui/icons/BugReport"
import MenuBookIcon from "@material-ui/icons/MenuBook"
import CommuteIcon from "@material-ui/icons/Commute"
import PanoramaIcon from "@material-ui/icons/Panorama"
import SignalWifiOffIcon from "@material-ui/icons/SignalWifiOff"
import LocationOnIcon from "@material-ui/icons/LocationOn"
import AirlineSeatReclineNormalIcon from "@material-ui/icons/AirlineSeatReclineNormal"
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle"
import ExitToAppIcon from "@material-ui/icons/ExitToApp"
import FormatAlignCenterIcon from "@material-ui/icons/FormatAlignCenter"
import MeetingRoomIcon from "@material-ui/icons/MeetingRoom"
import {Link, Route} from "react-router-dom"
import { Redirect } from "react-router-dom"
import Avatar from "@material-ui/core/Avatar"
import Badge from "@material-ui/core/Badge"

import Collapse from "@material-ui/core/Collapse"
import InboxIcon from "@material-ui/icons/MoveToInbox"
import DraftsIcon from "@material-ui/icons/Drafts"
import ExpandLess from "@material-ui/icons/ExpandLess"
import ExpandMore from "@material-ui/icons/ExpandMore"
import StarBorder from "@material-ui/icons/StarBorder"
import PeopleAltIcon from "@material-ui/icons/PeopleAlt"
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount"
import MarketersPanel from "./MarketersPanel";
import IssuanceMarketersPanel from "./IssuanceMarketersPanel";

const drawerWidth = 240

const StyledOnBadge = withStyles((theme: Theme) =>
      createStyles({
            badge: {
                  backgroundColor: "#44b700",
                  color: "#44b700",
                  boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
                  "&::after": {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                        animation: "$ripple 1.2s infinite ease-in-out",
                        border: "1px solid currentColor",
                        content: '""',
                  },
            },
            "@keyframes ripple": {
                  "0%": {
                        transform: "scale(.8)",
                        opacity: 1,
                  },
                  "100%": {
                        transform: "scale(2.4)",
                        opacity: 0,
                  },
            },
      })
)(Badge)

const StyledOffBadge = withStyles((theme: Theme) =>
      createStyles({
            badge: {
                  backgroundColor: "#eaeaea",
                  color: "#eaeaea",
                  boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
                  "&::after": {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                        animation: "$ripple 5s infinite ease-in-out",
                        border: "1px solid currentColor",
                        content: '""',
                  },
            },
            "@keyframes ripple": {
                  "0%": {
                        transform: "scale(.8)",
                        opacity: 1,
                  },
                  "100%": {
                        transform: "scale(2.4)",
                        opacity: 0,
                  },
            },
      })
)(Badge)

const StyledMenu = withStyles({
      paper: {
            border: "1px solid #d3d4d5",
      },
})((props: MenuProps) => (
      <Menu
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
            }}
            transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
            }}
            {...props}
      />
))
const StyledMenuItem = withStyles((theme) => ({
      root: {
            "&:focus": {
                  backgroundColor: theme.palette.primary.main,
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                        color: theme.palette.common.white,
                  },
            },
      },
}))(MenuItem)

const styles = (theme) => ({
      root: {
            display: "flex",
      },
      appBar: {
            transition: theme.transitions.create(["margin", "width"], {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.leavingScreen,
            }),
      },
      listitem: { fontSize: "8" },
      appBarShift: {
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(["margin", "width"], {
                  easing: theme.transitions.easing.easeOut,
                  duration: theme.transitions.duration.enteringScreen,
            }),
            marginRight: drawerWidth,
      },
      title: {
            flexGrow: 1,
            color: "white",
      },
      titletxt: {
            flexGrow: 1,
            color: "white",
            margin: "4px",
      },
      hide: {
            display: "none",
      },
      drawer: {
            width: drawerWidth,
            flexShrink: 0,
      },
      drawerPaper: {
            width: drawerWidth,
      },
      drawerHeader: {
            display: "flex",
            alignItems: "center",
            padding: theme.spacing(0, 1),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
            justifyContent: "flex-start",
      },
      content: {
            flexGrow: 1,
            padding: theme.spacing(0),
            transition: theme.transitions.create("margin", {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.leavingScreen,
            }),
            marginRight: -drawerWidth,
      },
      contentShift: {
            transition: theme.transitions.create("margin", {
                  easing: theme.transitions.easing.easeOut,
                  duration: theme.transitions.duration.enteringScreen,
            }),
            marginRight: 0,
      },
})

class Hedear extends Component {
      cookies = new Cookies()

      constructor(props) {
            super(props)
            this.state = {
                  open: false,
                  open1: false,
                  open2: false,
                  open3: false,
                  open4: false,
                  open5: false,
                  open6: false,
                  open7: false,
                  open8: false,

                  openAccountBox: false,
                  redirecthome: false,
                  redirectchangepass: false,
                  redirectchangeprofile: false,
                  redirectchangeEmployee: false,
                  redirectChangeFieldCompany: false,
                  redirectChangePackageinsurance: false,
                  redirectChangeManagdiscount: false,
                  redirectChangeInstalment: false,
                  redirectChangeOrganTherapyContrat: false,
                  redirectChangeOrganContrat: false,
                  redirectChangeDiscountcode: false,
                  redirectchangeCompany: false,
                  redirectChangeEvaluatorCo: false,
                  redirectChangeCar: false,
                  redirectChangeBossToEmployee: false,
                  redirectChangeThirdparty: false,
                  redirectChangeBodyCar: false,
                  redirectChangeTherapy: false,
                  redirectChangeAccident: false,
                  redirectChangeSmsReceiver: false,
                  redirectChangeSmsReceiverEngineeringSystem: false,
                  redirectMarketersPanel: false,
                  redirectIssuanceMarketersPanel: false,
                  redirectChangeElevator: false,
                  redirectChangeTravel: false,
                  redirectChangeCorona: false,
                  redirectChangePartnerRequest: false,
                  redirectChangeMarketer: false,
                  redirectGetLocation: false,
                  redirectChangeResponsdoctors: false,
                  redirectchangeResponseSupervisingEngineer: false,
                  redirectchangeResponseABN: false,
                  redirectChangeResbuildmng: false,
                  redirectChangeFireHome: false,
                  redirectChangeFireWarehouse: false,
                  redirectChangePet: false,
                  redirectChangeInvestment: false,
                  redirectChangeFireIndustrial: false,
                  redirectChangeFireNonIndustrial: false,
                  redirectChangeFireHouse: false,
                  redirectChangeFireProperty: false,
                  redirectChangeFireOwnership: false,
                  redirectChangeBuildingQuality: false,
                  redirectchangeRequiredimgdmg: false,
                  redirectChangeRequestQuestion: false,
                  redirectChangeSmsManage: false,
                  redirectchangeRequiredimgins: false,
                  redirectChangeParamstep: false,
                  redirectArchiveOrdersOffine: false,
                  redirectArchivePayOrders: false,
                  redirectArchivemaliOrders: false,
                  redirectArchiveNotPayOrders: false,
                  redirectChangeSendRequest: false,
                  redirectChangeRequestFinancialApproval: false,
                  redirectChangeRequestFinancialPay: false,
                  redirectChangeRefundUserFinancial: false,
                  redirectChangeReportPay: false,
                  redirectChangeReportDoc: false,
                  redirectChangeReportReferral: false,

                  redirectChangeBankGateWay: false,
                  redirectContentManager: false,
                  redirectChangeMsSMSHandler: false,

                  redirectChangeReportFinancial: false,
                  redirectChangeReportInstalment: false,
                  redirectChangeUserTherapy: false,
                  redirectChangeAddRequest: false,
                  redirectchangeFieldDamagefile: false,
                  redirectchangeFieldInsurance: false,
                  redirectChangeFieldinsuranceGroup: false,
                  redirectChangePermision: false,
                  redirectchangeChangeExpert: false,
                  redirectchangeChangeAgent: false,
                  redirectchangeChangeOrgan: false,
                  redirectchangeChangeKindsenddamagefile: false,
                  redirectchangeChangeKindsendrequest: false,
                  redirectprofile: false,
            }
      }

      handleClick = (index) => {
            if (index === "1") {
                  this.setState({ open1: !this.state.open1 }, () => {})
            } else if (index === "2") {
                  this.setState({ open2: !this.state.open2 }, () => {})
            } else if (index === "3") {
                  this.setState({ open3: !this.state.open3 }, () => {})
            } else if (index === "4") {
                  this.setState({ open4: !this.state.open4 }, () => {})
            } else if (index === "5") {
                  this.setState({ open5: !this.state.open5 }, () => {})
            } else if (index === "6") {
                  this.setState({ open6: !this.state.open6 }, () => {})
            } else if (index === "7") {
                  this.setState({ open7: !this.state.open7 }, () => {})
            } else if (index === "8") {
                  this.setState({ open8: !this.state.open8 }, () => {})
            }
      }

      handelChangeBankGateWay =() =>{
            this.setState({ openAccountBox: false, redirectChangeBankGateWay: true, open: false }, () => {
                  this.setState({ redirectChangeBankGateWay: false })
            })
      }
      handelContentManager =() =>{
            this.setState({ openAccountBox: false, redirectContentManager: true, open: false }, () => {
                  this.setState({ redirectContentManager: false })
            })
      }
      handelChangeMS_SMSHandler =() =>{
            this.setState({ openAccountBox: false, redirectChangeMsSMSHandler: true, open: false }, () => {
                  this.setState({ redirectChangeMsSMSHandler: false })
            })
      }

      handleChangePass = (event) => {
            this.setState({ openAccountBox: false, redirectchangepass: true, open: false }, () => {
                  this.setState({ redirectchangepass: false })
            })
      }

      handleChangeProfile = (event) => {
            this.setState({ openAccountBox: false, redirectchangeprofile: true, open: false }, () => {
                  this.setState({ redirectchangeprofile: false })
            })
      }
      handleChangeEmployee = (event) => {
            this.setState({ openAccountBox: false, redirectchangeEmployee: true, open: false }, () => {
                  this.setState({ redirectchangeEmployee: false })
            })
      }

      handleChangeFieldCompany = (event) => {
            this.setState({ openAccountBox: false, redirectChangeFieldCompany: true, open: false }, () => {
                  this.setState({ redirectChangeFieldCompany: false })
            })
      }

      handleChangePackageinsurance = (event) => {
            this.setState({ openAccountBox: false, redirectChangePackageinsurance: true, open: false }, () => {
                  this.setState({ redirectChangePackageinsurance: false })
            })
      }

      handleChangeManagdiscount = (event) => {
            this.setState({ openAccountBox: false, redirectChangeManagdiscount: true, open: false }, () => {
                  this.setState({ redirectChangeManagdiscount: false })
            })
      }

      handleChangeInstalment = (event) => {
            this.setState({ openAccountBox: false, redirectChangeInstalment: true, open: false }, () => {
                  this.setState({ redirectChangeInstalment: false })
            })
      }

      handleChangeOrganTherapyContrat = (event) => {
            this.setState({ openAccountBox: false, redirectChangeOrganTherapyContrat: true, open: false }, () => {
                  this.setState({ redirectChangeOrganTherapyContrat: false })
            })
      }

      handleChangeOrganContrat = (event) => {
            this.setState({ openAccountBox: false, redirectChangeOrganContrat: true, open: false }, () => {
                  this.setState({ redirectChangeOrganContrat: false })
            })
      }

      handleChangeDiscountcode = (event) => {
            this.setState({ openAccountBox: false, redirectChangeDiscountcode: true, open: false }, () => {
                  this.setState({ redirectChangeDiscountcode: false })
            })
      }

      handleChangeCompany = (event) => {
            this.setState({ openAccountBox: false, redirectchangeCompany: true, open: false }, () => {
                  this.setState({ redirectchangeCompany: false })
            })
      }

      handleChangeEvaluatorCo = (event) => {
            this.setState({ openAccountBox: false, redirectChangeEvaluatorCo: true, open: false }, () => {
                  this.setState({ redirectChangeEvaluatorCo: false })
            })
      }

      handleChangeCar = (event) => {
            this.setState({ openAccountBox: false, redirectChangeCar: true, open: false }, () => {
                  this.setState({ redirectChangeCar: false })
            })
      }
      handleChangeBossToEmployee = (event) => {
            this.setState({ openAccountBox: false, redirectChangeBossToEmployee: true, open: false }, () => {
                  this.setState({ redirectChangeBossToEmployee: false })
            })
      }

      handleChangeThirdparty = (event) => {
            this.setState({ openAccountBox: false, redirectChangeThirdparty: true, open: false }, () => {
                  this.setState({ redirectChangeThirdparty: false })
            })
      }

      handleChangeBodyCar = (event) => {
            this.setState({ openAccountBox: false, redirectChangeBodyCar: true, open: false }, () => {
                  this.setState({ redirectChangeBodyCar: false })
            })
      }

      handleChangeElevator = (event) => {
            this.setState({ openAccountBox: false, redirectChangeElevator: true, open: false }, () => {
                  this.setState({ redirectChangeElevator: false })
            })
      }

      handleChangeTravel = (event) => {
            this.setState({ openAccountBox: false, redirectChangeTravel: true, open: false }, () => {
                  this.setState({ redirectChangeTravel: false })
            })
      }

      handleChangeTherapy = (event) => {
            this.setState({ openAccountBox: false, redirectChangeTherapy: true, open: false }, () => {
                  this.setState({ redirectChangeTherapy: false })
            })
      }
      handleChangeAccident = (event) => {
            this.setState({ openAccountBox: false, redirectChangeAccident: true, open: false }, () => {
                  this.setState({ redirectChangeAccident: false })
            })
      }
      handleChangeSmsReceiver = (event) => {
            this.setState({ openAccountBox: false, redirectChangeSmsReceiver: true, open: false }, () => {
                  this.setState({ redirectChangeSmsReceiver: false })
            })
      }
      handleChangeSmsReceiverEngineeringSystem = (event) => {
            this.setState({ openAccountBox: false, redirectChangeSmsReceiverEngineeringSystem: true, open: false }, () => {
                  this.setState({ redirectChangeSmsReceiverEngineeringSystem: false })
            })
      }
      handletMarketersPanel = (event) => {
            this.setState({ openAccountBox: false, redirectMarketersPanel: true, open: false }, () => {
                  this.setState({ redirectMarketersPanel: false })
            })
      }
      handletIssuanceMarketersPanel = (event) => {
            this.setState({ openAccountBox: false, redirectIssuanceMarketersPanel: true, open: false }, () => {
                  this.setState({ redirectIssuanceMarketersPanel: false })
            })
      }

      handleChangeCorona = (event) => {
            this.setState({ openAccountBox: false, redirectChangeCorona: true, open: false }, () => {
                  this.setState({ redirectChangeCorona: false })
            })
      }

      handleChangeMarketer = (event) => {
            this.setState({ openAccountBox: false, redirectChangeMarketer: true, open: false }, () => {
                  this.setState({ redirectChangeMarketer: false })
            })
      }

      handleChangePartnerRequest = (event) => {
            this.setState({ openAccountBox: false, redirectChangePartnerRequest: true, open: false }, () => {
                  this.setState({ redirectChangePartnerRequest: false })
            })
      }


      handleGetLocation = (event) => {
            this.setState({ openAccountBox: false, redirectGetLocation: true, open: false }, () => {
                  this.setState({ redirectGetLocation: false })
            })
      }

      handleChangeResponsdoctors = (event) => {
            this.setState({ openAccountBox: false, redirectChangeResponsdoctors: true, open: false }, () => {
                  this.setState({ redirectChangeResponsdoctors: false })
            })
      }
      handlechangeResponseSupervisingEngineer = (event) => {
            this.setState({ openAccountBox: false, redirectchangeResponseSupervisingEngineer: true, open: false }, () => {
                  this.setState({ redirectchangeResponseSupervisingEngineer: false })
            })
      }
      handlechangeResponseABN = (event) => {
            this.setState({ openAccountBox: false, redirectchangeResponseABN: true, open: false }, () => {
                  this.setState({ redirectchangeResponseABN: false })
            })
      }

      handleChangeResbuildmng = (event) => {
            this.setState({ openAccountBox: false, redirectChangeResbuildmng: true, open: false }, () => {
                  this.setState({ redirectChangeResbuildmng: false })
            })
      }

      handleChangeFireHome = (event) => {
            this.setState({ openAccountBox: false, redirectChangeFireHome: true, open: false }, () => {
                  this.setState({ redirectChangeFireHome: false })
            })
      }
      handleChangeFireWarehouse = (event) => {
            this.setState({ openAccountBox: false, redirectChangeFireWarehouse: true, open: false }, () => {
                  this.setState({ redirectChangeFireWarehouse: false })
            })
      }
      handleChangePet = (event) => {
            this.setState({ openAccountBox: false, redirectChangePet: true, open: false }, () => {
                  this.setState({ redirectChangePet: false })
            })
      }
      handleChangeInvestment = (event) => {
            this.setState({ openAccountBox: false, redirectChangeInvestment: true, open: false }, () => {
                  this.setState({ redirectChangeInvestment: false })
            })
      }
      handleChangeFireIndustrial = (event) => {
            this.setState({ openAccountBox: false, redirectChangeFireIndustrial: true, open: false }, () => {
                  this.setState({ redirectChangeFireIndustrial: false })
            })
      }
      handleChangeFireHouse = (event) => {
            this.setState({ openAccountBox: false, redirectChangeFireHouse: true, open: false }, () => {
                  this.setState({ redirectChangeFireHouse: false })
            })
      }
      handleChangeFireProperty = (event) => {
            this.setState({ openAccountBox: false, redirectChangeFireProperty: true, open: false }, () => {
                  this.setState({ redirectChangeFireProperty: false })
            })
      }
      handleChangeFireOwnership = (event) => {
            this.setState({ openAccountBox: false, redirectChangeFireOwnership: true, open: false }, () => {
                  this.setState({ redirectChangeFireOwnership: false })
            })
      }
      handleChangeFireEmployeehouse = (event) => {
            this.setState({ openAccountBox: false, redirectChangeFireEmployeehouse: true, open: false }, () => {
                  this.setState({ redirectChangeFireEmployeehouse: false })
            })
      }
      handleChangeFireNonIndustrial = (event) => {
            this.setState({ openAccountBox: false, redirectChangeFireNonIndustrial: true, open: false }, () => {
                  this.setState({ redirectChangeFireNonIndustrial: false })
            })
      }

      handleChangeBuildingQuality = (event) => {
            this.setState({ openAccountBox: false, redirectChangeBuildingQuality: true, open: false }, () => {
                  this.setState({ redirectChangeBuildingQuality: false })
            })
      }
      handleChangeRequestQuestion = (event) => {
            this.setState({ openAccountBox: false, redirectChangeRequestQuestion: true, open: false }, () => {
                  this.setState({ redirectChangeRequestQuestion: false })
            })
      }

      handleChangeSmsManage = (event) => {
            this.setState({ openAccountBox: false, redirectChangeSmsManage: true, open: false }, () => {
                  this.setState({ redirectChangeSmsManage: false })
            })
      }
      handleChangeRequiredimgins = (event) => {
            this.setState({ openAccountBox: false, redirectchangeRequiredimgins: true, open: false }, () => {
                  this.setState({ redirectchangeRequiredimgins: false })
            })
      }

      handleChangeRequiredimgdmg = (event) => {
            this.setState({ openAccountBox: false, redirectchangeRequiredimgdmg: true, open: false }, () => {
                  this.setState({ redirectchangeRequiredimgdmg: false })
            })
      }

      handleChangeParamstep = (event) => {
            this.setState({ openAccountBox: false, redirectChangeParamstep: true, open: false }, () => {
                  this.setState({ redirectChangeParamstep: false })
            })
      }

      handleArchiveOrdersOffine = (event) => {
            this.setState({ openAccountBox: false, redirectArchiveOrdersOffine: true, open: false }, () => {
                  this.setState({ redirectArchiveOrdersOffine: false })
            })
      }

      handleArchivePayOrders = (event) => {
            this.setState({ openAccountBox: false, redirectArchivePayOrders: true, open: false }, () => {
                  this.setState({ redirectArchivePayOrders: false })
            })
      }
 handleArchiveMaliPayOrders = (event) => {
            this.setState({ openAccountBox: false, redirectArchivemaliOrders: true, open: false }, () => {
                  this.setState({ redirectArchivemaliOrders: false })
            })
      }

      handleArchiveNotPayOrders = (event) => {
            this.setState({ openAccountBox: false, redirectArchiveNotPayOrders: true, open: false }, () => {
                  this.setState({ redirectArchiveNotPayOrders: false })
            })
      }

      handleChangeSendRequest = (event) => {
            this.setState({ openAccountBox: false, redirectChangeSendRequest: true, open: false }, () => {
                  this.setState({ redirectChangeSendRequest: false })
            })
      }

      handleChangeRequestFinancialApproval = (event) => {
            this.setState({ openAccountBox: false, redirectChangeRequestFinancialApproval: true, open: false }, () => {
                  this.setState({ redirectChangeRequestFinancialApproval: false })
            })
      }

      handleChangeRequestFinancialPay = (event) => {
            this.setState({ openAccountBox: false, redirectChangeRequestFinancialPay: true, open: false }, () => {
                  this.setState({ redirectChangeRequestFinancialPay: false })
            })
      }

      handleChangeRefundUserFinancial = (event) => {
            this.setState({ openAccountBox: false, redirectChangeRefundUserFinancial: true, open: false }, () => {
                  this.setState({ redirectChangeRefundUserFinancial: false })
            })
      }

      handleChangeReportPay = (event) => {
            this.setState({ openAccountBox: false, redirectChangeReportPay: true, open: false }, () => {
                  this.setState({ redirectChangeReportPay: false })
            })
      }
      handleChangeReportDoc = (event) => {
            this.setState({ openAccountBox: false, redirectChangeReportDoc: true, open: false }, () => {
                  this.setState({ redirectChangeReportDoc: false })
            })
      }

      handleChangeReportFinancial = (event) => {
            this.setState({ openAccountBox: false, redirectChangeReportFinancial: true, open: false }, () => {
                  this.setState({ redirectChangeReportFinancial: false })
            })
      }

      handleChangeReportReferral = (event) => {
            this.setState({ openAccountBox: false, redirectChangeReportReferral: true, open: false }, () => {
                  this.setState({ redirectChangeReportReferral: false })
            })
      }

      handleChangeAddRequest = (event) => {
            this.setState({ openAccountBox: false, redirectChangeAddRequest: true, open: false }, () => {
                  this.setState({ redirectChangeAddRequest: false })
            })
      }

      handleChangeUserTherapy = (event) => {
            this.setState({ openAccountBox: false, redirectChangeUserTherapy: true, open: false }, () => {
                  this.setState({ redirectChangeUserTherapy: false })
            })
      }

      handleChangeReportInstalment = (event) => {
            this.setState({ openAccountBox: false, redirectChangeReportInstalment: true, open: false }, () => {
                  this.setState({ redirectChangeReportInstalment: false })
            })
      }

      handleChangeFieldInsurance = (event) => {
            this.setState({ openAccountBox: false, redirectchangeFieldInsurance: true, open: false }, () => {
                  this.setState({ redirectchangeFieldInsurance: false })
            })
      }

      handleChangeFieldinsuranceGroup = (event) => {
            this.setState({ openAccountBox: false, redirectChangeFieldinsuranceGroup: true, open: false }, () => {
                  this.setState({ redirectChangeFieldinsuranceGroup: false })
            })
      }

      handleChangeFieldDamagefile = (event) => {
            this.setState({ openAccountBox: false, redirectchangeFieldDamagefile: true, open: false }, () => {
                  this.setState({ redirectchangeFieldDamagefile: false })
            })
      }

      handleChangePermision = (event) => {
            this.setState({ openAccountBox: false, redirectChangePermision: true, open: false }, () => {
                  this.setState({ redirectChangePermision: false })
            })
      }

      handleChangeExpert = (event) => {
            this.setState({ openAccountBox: false, redirectchangeChangeExpert: true, open: false }, () => {
                  this.setState({ redirectchangeChangeExpert: false })
            })
      }

      handleChangeAgent = (event) => {
            this.setState({ openAccountBox: false, redirectchangeChangeAgent: true, open: false }, () => {
                  this.setState({ redirectchangeChangeAgent: false })
            })
      }

      handleChangeOrgan = (event) => {
            this.setState({ openAccountBox: false, redirectchangeChangeOrgan: true, open: false }, () => {
                  this.setState({ redirectchangeChangeOrgan: false })
            })
      }

      handleChangeKindsenddamagefile = (event) => {
            this.setState({ openAccountBox: false, redirectchangeChangeKindsenddamagefile: true, open: false }, () => {
                  this.setState({ redirectchangeChangeKindsenddamagefile: false })
            })
      }

      handleChangeKindsendrequest = (event) => {
            this.setState({ openAccountBox: false, redirectchangeChangeKindsendrequest: true, open: false }, () => {
                  this.setState({ redirectchangeChangeKindsendrequest: false })
            })
      }

      handleExitAccount = (event) => {
            this.cookies.remove("employee_name", { path: "/" })
            this.cookies.remove("employee_family", { path: "/" })
            this.cookies.remove("employee_id", { path: "/" })
            this.cookies.remove("employee_employee", { path: "/" })
            this.cookies.remove("employee_mobile", { path: "/" })
            this.cookies.remove("employee_token_str", { path: "/" })

            this.props.dispatch({
                  type: "CLEARPROPATEEMPLOYEE",
            })

            this.setState({ openAccountBox: false, redirecthome: true }, () => {
                  this.setState({ redirecthome: false })
            })
      }

      handleClickcloseAccountBox = (event) => {
            this.setState({ openAccountBox: false })
      }

      handleClickAccountBox = (event) => {
            this.setState({ openAccountBox: true })
      }

      handleDrawerOpen = (event) => {
            this.setState({ open: true })
      }

      handleDrawerClose = (event) => {
            this.setState({ open: false })
      }

      render() {
            const { classes } = this.props
            const {
                  redirectchangeFieldDamagefile,
                  redirectchangeRequiredimgdmg,
                  redirectChangeReportReferral,
                  redirectChangeReportFinancial,
                  redirecthome,
                  redirectchangepass,
                  redirectChangeBankGateWay,
                  redirectContentManager,
                  redirectChangeMsSMSHandler,
                  redirectchangeprofile,
                  redirectchangeEmployee,
                  redirectChangeFieldCompany,
                  redirectChangePackageinsurance,
                  redirectChangeManagdiscount,
                  redirectChangeInstalment,
                  redirectChangeOrganContrat,
                  redirectChangeOrganTherapyContrat,
                  redirectChangeDiscountcode,
                  redirectchangeCompany,
                  redirectChangeEvaluatorCo,
                  redirectChangeCar,
                  redirectChangeBossToEmployee,
                  redirectChangeThirdparty,
                  redirectChangeBodyCar,
                  redirectChangeTherapy,
                  redirectChangeAccident,
                  redirectChangeSmsReceiver,
                  redirectChangeSmsReceiverEngineeringSystem,
                  redirectMarketersPanel,
                  redirectIssuanceMarketersPanel,
                  redirectChangeElevator,
                  redirectChangeTravel,
                  redirectChangeCorona,
                  redirectChangePartnerRequest,
                  redirectChangeMarketer,
                  redirectGetLocation,
                  redirectChangeResponsdoctors,
                  redirectchangeResponseSupervisingEngineer,
                  redirectchangeResponseABN,
                  redirectChangeResbuildmng,
                  redirectChangeFireHome,
                  redirectChangeFireWarehouse,
                  redirectChangePet,
                  redirectChangeInvestment,
                  redirectChangeFireIndustrial,
                  redirectChangeFireHouse,
                  redirectChangeFireProperty,
                  redirectChangeFireOwnership,
                  redirectChangeFireEmployeehouse,
                  redirectChangeFireNonIndustrial,
                  redirectChangeBuildingQuality,
                  redirectChangeRequestQuestion,
                  redirectChangeSmsManage,
                  redirectchangeRequiredimgins,
                  redirectChangeParamstep,
                  redirectArchiveOrdersOffine,
                  redirectArchivePayOrders,
                  redirectArchivemaliOrders,
                  redirectArchiveNotPayOrders,
                  redirectChangeSendRequest,
                  redirectChangeRequestFinancialApproval,
                  redirectChangeRequestFinancialPay,
                  redirectChangeRefundUserFinancial,
                  redirectChangeReportDoc,
                  redirectChangeReportPay,
                  redirectChangeAddRequest,
                  redirectChangeUserTherapy,
                  redirectChangeReportInstalment,
                  redirectchangeFieldInsurance,
                  redirectChangeFieldinsuranceGroup,
                  redirectChangePermision,
                  redirectchangeChangeOrgan,
                  redirectchangeChangeExpert,
                  redirectchangeChangeAgent,
                  redirectchangeChangeKindsenddamagefile,
                  redirectchangeChangeKindsendrequest,
                  open,
                  open1,
                  open2,
                  open3,
                  open4,
                  open5,
                  open6,
                  open7,
                  open8,

                  openAccountBox,
            } = this.state

            const { employee_id, employee_name, employee_family, employee_image } = this.props.employeeProperty
            const id = this.cookies.get("employee_id")
            const role_name = this.cookies.get("role_name")
            console.log('role_name',role_name)
            let roles = this.cookies.get("roles") || "[]";
            console.log("roles", roles); // ["admin", "editor", "viewer"]
            // {console.log("employee_id",this.cookies.get("employee_id"))}
            // console.log("کاربر:", this.props.employeeProperty);


            return (

                  <div className={classes.root}>
                        {redirecthome ? <Redirect to="/" /> : null}

                                  {redirectMarketersPanel ? <Redirect to="/MarketersPanel" /> : null}
                                  {redirectIssuanceMarketersPanel ? <Redirect to="/IssuanceMarketersPanel" /> : null}
                                  {redirectchangepass ? <Redirect push to="/changepass" /> : null}
                                  {redirectChangeBankGateWay ? <Redirect push to="/paymentGateway" /> : null}
                                  {redirectContentManager ? <Redirect push to="/contentManager" /> : null}
                                  {redirectChangeMsSMSHandler ? <Redirect push to="/mySweetSMHandler" /> : null}
                                  {redirectchangeprofile ? <Redirect to="/editprofile" /> : null}
                                  {redirectchangeEmployee ? <Redirect to="/changeemployee" /> : null}
                                  {redirectchangeChangeExpert ? <Redirect to="/changeexpert" /> : null}
                                  {redirectchangeChangeAgent ? <Redirect to="/changeagent" /> : null}
                                  {redirectchangeChangeOrgan ? <Redirect to="/changeOrgan" /> : null}
                                  {redirectchangeChangeKindsendrequest ? <Redirect to="/changekindsendrequest" /> : null}
                                  {redirectchangeChangeKindsenddamagefile ? <Redirect to="/changekindsenddamagefile" /> : null}
                                  {redirectchangeCompany ? <Redirect to="/changecompany" /> : null}
                                  {redirectChangeEvaluatorCo ? <Redirect to="/Changeevaluatorco" /> : null}
                                  {redirectchangeFieldDamagefile ? <Redirect to="/changefielddamagefile" /> : null}
                                  {redirectChangeFieldinsuranceGroup ? <Redirect to="/changefieldinsurancegroup" /> : null}
                                  {redirectchangeFieldInsurance ? <Redirect to="/changefieldinsurance" /> : null}
                                  {redirectChangePermision ? <Redirect to="/changepermision" /> : null}
                                  {redirectChangeFieldCompany ? <Redirect to="/changefieldcompany" /> : null}
                                  {redirectChangePackageinsurance ? <Redirect to="/changepackageinsurance" /> : null}
                                  {redirectChangeManagdiscount ? <Redirect to="/changemanagdiscount" /> : null}
                                  {redirectChangeInstalment ? <Redirect to="/changeinstalment" /> : null}
                                  {redirectChangeOrganTherapyContrat ? <Redirect to="/changeorgantherapycontrat" /> : null}
                                  {redirectChangeOrganContrat ? <Redirect to="/changeorgancontrat" /> : null}
                                  {redirectChangeDiscountcode ? <Redirect to="/changediscountcode" /> : null}
                                  {redirectchangeRequiredimgdmg ? <Redirect to="/changerequiredimgdmg" /> : null}
                                  {redirectChangeRequestQuestion ? <Redirect to="/changerequestquestion" /> : null}
                                  {redirectChangeSmsManage ? <Redirect to="/changesmsmanage" /> : null}
                                  {redirectchangeRequiredimgins ? <Redirect to="/changerequiredimgins" /> : null}
                                  {redirectChangeParamstep ? <Redirect to="/changeparamstep" /> : null}
                                  {redirectArchiveNotPayOrders ? <Redirect to="/archiveordersnotpay" /> : null}
                                  {redirectArchiveOrdersOffine ? <Redirect to="/archiveordersoffine" /> : null}
                                  {redirectArchivePayOrders ? <Redirect to="/archiveorderpay" /> : null}
                                  {redirectArchivemaliOrders ? <Redirect to="/archiveordermali" /> : null}
                                  {redirectChangeSendRequest ? <Redirect to="/changesendrequest" /> : null}
                                  {redirectChangeRequestFinancialApproval ? <Redirect to="/changerequestfinancialapproval" /> : null}
                                  {redirectChangeRequestFinancialPay ? <Redirect to="/changerequestfinancialpay" /> : null}
                                  {redirectChangeRefundUserFinancial ? <Redirect to="/changerefunduserfinancial" /> : null}
                                  {redirectChangeReportDoc ? <Redirect to="/changereportdoc" /> : null}
                                  {redirectChangeReportPay ? <Redirect to="/changereportpay" /> : null}
                                  {redirectChangeAddRequest ? <Redirect to="/changeaddrequest" /> : null}
                                  {redirectChangeUserTherapy ? <Redirect to="/changeusertherapy" /> : null}
                                  {redirectChangeReportInstalment ? <Redirect to="/changeReportInstalment" /> : null}
                                  {redirectChangeReportReferral ? <Redirect to="/ChangeReportReferral" /> : null}
                                  {redirectChangeReportFinancial ? <Redirect to="/changeReportfinancial" /> : null}
                                  {redirectChangeCar ? <Redirect to="/changecar" /> : null}
                                  {redirectChangeBossToEmployee ? <Redirect to="/changeBossToEmployee" /> : null}
                                  {redirectChangeThirdparty ? <Redirect to="/changethirdparty" /> : null}
                                  {redirectChangeBodyCar ? <Redirect to="/changebodycar" /> : null}
                                  {redirectChangeTherapy ? <Redirect to="/changetherapy" /> : null}
                                  {redirectChangeAccident ? <Redirect to="/changeaccident" /> : null}
                                  {redirectChangeSmsReceiver ? <Redirect to="/ChangeSmsReceiver" /> : null}
                                  {redirectChangeSmsReceiverEngineeringSystem ? <Redirect to="/ChangeSmsReceiverEngineeringSystem" /> : null}
                                  {redirectChangeElevator ? <Redirect to="/changeelevator" /> : null}
                                  {redirectChangeTravel ? <Redirect to="/changetravel" /> : null}
                                  {redirectChangeCorona ? <Redirect to="/changecorona" /> : null}
                                  {redirectChangePartnerRequest ? <Redirect to="/changepartnerrequest" /> : null}
                                  {redirectChangeMarketer ? <Redirect to="/changemarketer" /> : null}
                                  {redirectGetLocation ? <Redirect to="/getlocation" /> : null}
                                  {redirectChangeResponsdoctors ? <Redirect to="/changeresponsdoctors" /> : null}
                                  {redirectchangeResponseSupervisingEngineer ? <Redirect to="/changeResponseSupervisingEngineer" /> : null}
                                  {redirectchangeResponseABN ? <Redirect to="/changeResponseABN" /> : null}
                                  {redirectChangeResbuildmng ? <Redirect to="/changeResbuildmng" /> : null}
                                  {redirectChangeFireHome ? <Redirect to="/changefirehome" /> : null}
                                  {redirectChangeFireWarehouse ? <Redirect to="/changefirewarehouse" /> : null}
                                  {redirectChangePet ? <Redirect to="/changepet" /> : null}
                                  {redirectChangeInvestment ? <Redirect to="/changeinvestment" /> : null}
                                  {redirectChangeFireIndustrial ? <Redirect to="/changefireindustrial" /> : null}
                                  {redirectChangeFireHouse ? <Redirect to="/changefirehouse" /> : null}
                                  {redirectChangeFireProperty ? <Redirect to="/changefireproperty" /> : null}
                                  {redirectChangeFireOwnership ? <Redirect to="/changefireownership" /> : null}
                                  {redirectChangeFireEmployeehouse ? <Redirect to="/changefireemployeehouse" /> : null}
                                  {redirectChangeFireNonIndustrial ? <Redirect to="/changefirenonindustrial" /> : null}
                                  {redirectChangeBuildingQuality ? <Redirect to="/changebuildingquality" /> : null}






                        <CssBaseline />
                        <AppBar
                              position="fixed"
                              className={clsx(classes.appBar, {
                                    [classes.appBarShift]: open,
                              })}
                        >
                              <Toolbar>
                                    <IconButton
                                          color="inherit"
                                          aria-label="open drawer"
                                          edge="end"
                                          onClick={this.handleDrawerOpen}
                                          className={clsx(open && classes.hide)}
                                    >
                                          <MenuIcon />
                                    </IconButton>
                                    <Link to="/">
                                          <IconButton className={classes.title} color="inherit" aria-label="open drawer" edge="end">
                                                <HomeIcon colorSecondary />
                                          </IconButton>
                                    </Link>
                                    <Typography variant="h7" noWrap className={classes.title}>
                                          پنل مدیریتی 7-24{" "}
                                    </Typography>
                                    {employee_id === null ? (
                                          <Link to="/login">
                                                <Button className={classes.title}>ورود</Button>
                                          </Link>
                                    ) : (
                                          <Typography align="left" variant="h7" noWrap className={classes.titletxt}>
                                                {employee_name + " " + employee_family}{" "}
                                          </Typography>
                                    )}
                                    {employee_id === null ? (
                                          <Avatar alt="Remy Sharp" src={employee_image} />
                                    ) : (
                                          <div>
                                                <IconButton color="inherit" aria-label="open drawer" edge="end" onClick={this.handleClickAccountBox}>
                                                      <StyledOnBadge
                                                            overlap="circle"
                                                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                                            variant="dot"
                                                      >
                                                            <Avatar alt="Remy Sharp" src={employee_image} />
                                                      </StyledOnBadge>
                                                </IconButton>
                                                <StyledMenu
                                                      id="customized-menu"
                                                      // anchorEl={anchorEl}
                                                      keepMounted
                                                      open={openAccountBox}
                                                      onClose={this.handleClickcloseAccountBox}
                                                >
                                                      <StyledMenuItem onClick={this.handleChangeProfile}>
                                                            <ListItemIcon>
                                                                  <PersonOutlineIcon fontSize="small" />
                                                            </ListItemIcon>
                                                            <ListItemText className={classes.listitem} primary="ویرایش پروفایل" />
                                                      </StyledMenuItem>
                                                      <StyledMenuItem onClick={this.handleChangePass}>
                                                            <ListItemIcon>
                                                                  <LockOpenIcon fontSize="small" />
                                                            </ListItemIcon>
                                                            <ListItemText primary="تغییر رمز" />
                                                      </StyledMenuItem>
                                                      <StyledMenuItem onClick={this.handleExitAccount}>
                                                            <ListItemIcon>
                                                                  <ExitToAppIcon fontSize="small" />
                                                            </ListItemIcon>
                                                            <ListItemText primary="خروج" />
                                                      </StyledMenuItem>
                                                </StyledMenu>
                                          </div>
                                    )}
                              </Toolbar>
                        </AppBar>
                        <main
                              className={clsx(classes.content, {
                                    [classes.contentShift]: open,
                              })}
                        >
                              <div className={classes.drawerHeader} />
                        </main>


                        <Drawer
                            className={classes.drawer}
                            variant="persistent"
                            anchor="right"
                            open={open}
                            classes={{ paper: classes.drawerPaper }}
                        >
                              <div className={classes.drawerHeader}>
                                    <IconButton onClick={this.handleDrawerClose}>
                                          <ChevronLeftIcon />
                                    </IconButton>
                              </div>
                              <Divider />
                                    {/* رول واحد تمدیدی */}
                                    {roles.includes("واحد تمدیدی") && (
                                        <List>
                                              <ListItem button onClick={this.handletMarketersPanel}>
                                                    <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                    <ListItemText>پنل فروش</ListItemText>
                                              </ListItem>
                                        </List>
                                    )}

                                    {/* رول واحد صدور */}
                                    {roles.includes("واحد صدور") && (
                                        <List>
                                              <ListItem button onClick={this.handletIssuanceMarketersPanel}>
                                                    <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                    <ListItemText>پنل صدور</ListItemText>
                                              </ListItem>
                                        </List>
                                    )}

                              {roles.includes("واحد اتومبیل") && (
                                  <List>
                                        <ListItem button onClick={this.handleChangeSmsReceiver}>
                                              <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                              <ListItemText>مدیریت پیام های دریافتی</ListItemText>
                                        </ListItem>
                                  </List>
                              )}
                              {roles.includes("واحد مالی") && (
                                  <List>

                                  <ListItem button onClick={() => this.handleClick("8")}>
                                        <ListItemIcon><MonetizationOnIcon /></ListItemIcon>
                                        <ListItemText primary="مالی" />
                                        {open8 ? <ExpandLess /> : <ExpandMore />}
                                  </ListItem>

                                    <Collapse in={open8} timeout="auto" unmountOnExit style={{ backgroundColor: "#F6F5F5" }}>
                                    <List component="div" disablePadding>
                                    {/*<ListItem button onClick={this.handleChangeRequestFinancialApproval}>*/}
                                    {/*<ListItemIcon><PaymentIcon /></ListItemIcon>*/}
                                    {/*<ListItemText>مدیریت تایید مالی درخواست ها</ListItemText>*/}
                                    {/*</ListItem>*/}
                                    {/*<ListItem button onClick={this.handleChangeRequestFinancialPay}>*/}
                                    {/*<ListItemIcon><PlaylistAddCheckTwoToneIcon /></ListItemIcon>*/}
                                    {/*<ListItemText>مدیریت ارسال برای پرداخت مالی</ListItemText>*/}
                                    {/*</ListItem>*/}
                                    {/*<ListItem button onClick={this.handleChangeRefundUserFinancial}>*/}
                                    {/*<ListItemIcon><DescriptionIcon /></ListItemIcon>*/}
                                    {/*<ListItemText>مدیریت پرداخت درخواست بازگشت وجه</ListItemText>*/}
                                    {/*</ListItem>*/}
                                    {/*<ListItem button onClick={this.handleChangeReportInstalment}>*/}
                                    {/*<ListItemIcon><AssignmentTurnedInIcon /></ListItemIcon>*/}
                                    {/*<ListItemText>وصول تعهد ها</ListItemText>*/}
                                    {/*</ListItem>*/}
                                    <ListItem button onClick={this.handleChangeReportFinancial}>
                                    <ListItemIcon><AttachMoneyIcon /></ListItemIcon>
                                    <ListItemText>گزارشات مالی</ListItemText>
                                    </ListItem>
                                    <ListItem button onClick={this.handleChangeReportPay}>
                                    <ListItemIcon><MonetizationOnIcon /></ListItemIcon>
                                    <ListItemText>پرداخت های درگاه</ListItemText>
                                    </ListItem>
                                    {/*<ListItem button onClick={this.handleChangeReportDoc}>*/}
                                    {/*<ListItemIcon><PlaylistAddCheckIcon /></ListItemIcon>*/}
                                    {/*<ListItemText>مدیریت تولید و ارسال اسناد مالی</ListItemText>*/}
                                    {/*</ListItem>*/}

                                          <ListItem button onClick={this.handleArchiveMaliPayOrders}>
                                                <ListItemIcon><AssignmentReturnIcon /></ListItemIcon>
                                                <ListItemText>گزارش مالی درخواست ها</ListItemText>
                                          </ListItem>
                                    </List>
                                    </Collapse>

                                        <ListItem button onClick={this.handleChangeMarketer}>
                                              <ListItemIcon><PeopleOutlineIcon /></ListItemIcon>
                                              <ListItemText>مدیریت بازاریابان</ListItemText>
                                        </ListItem>
                                  </List>



                              )}


                              {roles.includes("پیش فرض") && (
                                        <>
                                        <List>


                                        {/* پروفایل و تغییر رمز */}
                                        <ListItem button onClick={this.handleChangeProfile}>
                                              <ListItemIcon><PersonOutlineIcon /></ListItemIcon>
                                              <ListItemText>ویرایش پروفایل</ListItemText>
                                        </ListItem>
                                        <ListItem button onClick={this.handleChangePass}>
                                              <ListItemIcon><LockOpenIcon /></ListItemIcon>
                                              <ListItemText>تغییر رمز</ListItemText>
                                        </ListItem>
                                        <Divider />

                                        {/* کارمندان */}
                                        <ListItem button onClick={() => this.handleClick("1")}>
                                              <ListItemIcon><SupervisorAccountIcon /></ListItemIcon>
                                              <ListItemText primary="کارمندان" />
                                              {open1 ? <ExpandLess /> : <ExpandMore />}
                                        </ListItem>
                                        <Collapse in={open1} timeout="auto" unmountOnExit style={{ backgroundColor: "#F6F5F5" }}>
                                              <List component="div" disablePadding>
                                                    <ListItem button onClick={this.handleChangeEmployee}>
                                                          <ListItemIcon><PeopleIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت کارمندان</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangePermision}>
                                                          <ListItemIcon><PeopleAltIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت دسترسی به کارمندان</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleGetLocation}>
                                                          <ListItemIcon><LocationOnIcon /></ListItemIcon>
                                                          <ListItemText>موقعیت کاربران</ListItemText>
                                                    </ListItem>
                                              </List>
                                        </Collapse>
                                        <Divider />

                                        {/* سازمان ها */}
                                        <ListItem button onClick={() => this.handleClick("2")}>
                                              <ListItemIcon><BusinessTwoToneIcon /></ListItemIcon>
                                              <ListItemText primary="سازمان ها" />
                                              {open2 ? <ExpandLess /> : <ExpandMore />}
                                        </ListItem>
                                        <Collapse in={open2} timeout="auto" unmountOnExit style={{ backgroundColor: "#F6F5F5" }}>
                                              <List component="div" disablePadding>
                                                    <ListItem button onClick={this.handleChangeOrgan}>
                                                          <ListItemIcon><BusinessIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت سازمان ها</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeOrganContrat}>
                                                          <ListItemIcon><BusinessTwoToneIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت قرارداد های سازمان</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeOrganTherapyContrat}>
                                                          <ListItemIcon><BusinessIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت قرارداد های درمان سازمان</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeUserTherapy}>
                                                          <ListItemIcon><AssignmentTurnedInIcon /></ListItemIcon>
                                                          <ListItemText>اعضای درمان سازمان</ListItemText>
                                                    </ListItem>
                                              </List>
                                        </Collapse>
                                        <Divider />

                                        {/* خسارت درمان */}
                                        <ListItem button onClick={() => this.handleClick("3")}>
                                              <ListItemIcon><PanoramaIcon /></ListItemIcon>
                                              <ListItemText primary="خسارت درمان" />
                                              {open3 ? <ExpandLess /> : <ExpandMore />}
                                        </ListItem>
                                        <Collapse in={open3} timeout="auto" unmountOnExit style={{ backgroundColor: "#F6F5F5" }}>
                                              <List component="div" disablePadding>
                                                    <ListItem button onClick={this.handleChangeEvaluatorCo}>
                                                          <ListItemIcon><BusinessTwoToneIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت شرکت های ارزیاب خسارت</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeRequiredimgdmg}>
                                                          <ListItemIcon><PanoramaIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت عکس های مورد نیاز پرونده خسارت</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeKindsenddamagefile}>
                                                          <ListItemIcon><MenuBookIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت توزیع پرونده های خسارت</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeExpert}>
                                                          <ListItemIcon><AccessibilityIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت کارشناسان خسارت</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeFieldDamagefile}>
                                                          <ListItemIcon><LocalHospitalIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت فیلد های خسارت درمان</ListItemText>
                                                    </ListItem>
                                              </List>
                                        </Collapse>
                                        <Divider />

                                        {/* شرکت ها و رشته و نمایندگان */}
                                        <ListItem button onClick={() => this.handleClick("4")}>
                                              <ListItemIcon><AssessmentIcon /></ListItemIcon>
                                              <ListItemText primary="شرکت ها و رشته و نمایندگان" />
                                              {open4 ? <ExpandLess /> : <ExpandMore />}
                                        </ListItem>
                                        <Collapse in={open4} timeout="auto" unmountOnExit style={{ backgroundColor: "#F6F5F5" }}>
                                              <List component="div" disablePadding>
                                                    <ListItem button onClick={this.handleChangeFieldInsurance}>
                                                          <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت رشته های بیمه</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeFieldinsuranceGroup}>
                                                          <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت گروهبندی رشته های بیمه</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeCompany}>
                                                          <ListItemIcon><BusinessIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت شرکت های بیمه</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeFieldCompany}>
                                                          <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت رشته و شرکت بیمه</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangePackageinsurance}>
                                                          <ListItemIcon><AssessmentIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت پکیج های بیمه</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeAgent}>
                                                          <ListItemIcon><SupervisedUserCircleIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت نمایندگان</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeRequiredimgins}>
                                                          <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت عکس های مورد نیاز هر رشته</ListItemText>
                                                    </ListItem>
                                              </List>
                                        </Collapse>
                                        <Divider />

                                        {/* اقساط / تخفیف ها */}
                                        <ListItem button onClick={() => this.handleClick("5")}>
                                              <ListItemIcon><FormatListBulletedIcon /></ListItemIcon>
                                              <ListItemText primary="اقساط / تخفیف ها" />
                                              {open5 ? <ExpandLess /> : <ExpandMore />}
                                        </ListItem>
                                        <Collapse in={open5} timeout="auto" unmountOnExit style={{ backgroundColor: "#F6F5F5" }}>
                                              <List component="div" disablePadding>
                                                    <ListItem button onClick={this.handleChangeInstalment}>
                                                          <ListItemIcon><FormatListBulletedIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت شرایط اقساط</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeManagdiscount}>
                                                          <ListItemIcon><AssessmentIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت تخفیف مدیریتی</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeDiscountcode}>
                                                          <ListItemIcon><TextureIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت کد تخفیف</ListItemText>
                                                    </ListItem>
                                              </List>
                                        </Collapse>
                                        <Divider />

                                        {/* درخواست های بیمه */}
                                        <ListItem button onClick={() => this.handleClick("6")}>
                                              <ListItemIcon><FormatAlignCenterIcon /></ListItemIcon>
                                              <ListItemText primary="درخواست های بیمه" />
                                              {open6 ? <ExpandLess /> : <ExpandMore />}
                                        </ListItem>
                                        <Collapse in={open6} timeout="auto" unmountOnExit style={{ backgroundColor: "#F6F5F5" }}>
                                              <List component="div" disablePadding>
                                                    <ListItem button onClick={this.handleChangeKindsendrequest}>
                                                          <ListItemIcon><FormatAlignCenterIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت توزیع درخواست ها</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleArchivePayOrders}>
                                                          <ListItemIcon><AssignmentReturnIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت درخواست های ارجاع شده</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleArchiveMaliPayOrders}>
                                                          <ListItemIcon><AssignmentReturnIcon /></ListItemIcon>
                                                          <ListItemText>گزارش مالی درخواست ها</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleArchiveNotPayOrders}>
                                                          <ListItemIcon><MoneyOffIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت درخواست ها پرداخت نشده</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleArchiveOrdersOffine}>
                                                          <ListItemIcon><SignalWifiOffIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت قیمت دهی به درخواست های آفلاین</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeSendRequest}>
                                                          <ListItemIcon><SendIcon /></ListItemIcon>
                                                          <ListItemText>مدیریت ارسال درخواست ها</ListItemText>
                                                    </ListItem>
                                                    <ListItem button onClick={this.handleChangeAddRequest}>
                                                          <ListItemIcon><AssignmentTurnedInIcon /></ListItemIcon>
                                                          <ListItemText>اضافه کردن درخواست های گروهی</ListItemText>
                                                    </ListItem>
                                              </List>
                                        </Collapse>
                                        <Divider />
                                                    {/* رشته های بیمه ای */}
                                              <ListItem button onClick={() => this.handleClick("7")}>
                                                    <ListItemIcon><InboxIcon /></ListItemIcon>
                                                    <ListItemText primary="رشته های بیمه ای" />
                                                    {open7 ? <ExpandLess /> : <ExpandMore />}
                                              </ListItem>
                                              <Collapse in={open7} timeout="auto" unmountOnExit style={{ backgroundColor: "#F6F5F5" }}>
                                                    <List component="div" disablePadding>
                                                          <ListItem button onClick={this.handleChangeThirdparty}>
                                                                <ListItemIcon><CommuteIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت شخص ثالث</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeBodyCar}>
                                                                <ListItemIcon><DriveEtaIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت بدنه اتوموبیل</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangePet}>
                                                                <ListItemIcon><DriveEtaIcon /></ListItemIcon>
                                                                <ListItemText>بیمه حیوانات خانگی</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeInvestment}>
                                                                <ListItemIcon><DriveEtaIcon /></ListItemIcon>
                                                                <ListItemText>بیمه سرمایه‌گذاری</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeFireHome}>
                                                                <ListItemIcon><WhatshotTwoToneIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت آتش سوزی مسکونی</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeFireWarehouse}>
                                                                <ListItemIcon><WhatshotTwoToneIcon /></ListItemIcon>
                                                                <ListItemText>بیمه آتش‌سوزی انبار – بانک صنعت و معدن</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeFireIndustrial}>
                                                                <ListItemIcon><WhatshotTwoToneIcon /></ListItemIcon>
                                                                <ListItemText>بیمه آتش‌سوزی صنعتی – بانک صنعت و معدن</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeFireNonIndustrial}>
                                                                <ListItemIcon><WhatshotTwoToneIcon /></ListItemIcon>
                                                                <ListItemText>بیمه آتش‌سوزی غیر صنعتی – بانک صنعت و معدن</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeFireHouse}>
                                                                <ListItemIcon><WhatshotTwoToneIcon /></ListItemIcon>
                                                                <ListItemText>بیمه آتش‌سوزی مسکونی – بانک صنعت و معدن</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeFireProperty}>
                                                                <ListItemIcon><WhatshotTwoToneIcon /></ListItemIcon>
                                                                <ListItemText>بیمه آتش‌سوزی اموال - بانک صنعت و معدن</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeFireOwnership}>
                                                                <ListItemIcon><WhatshotTwoToneIcon /></ListItemIcon>
                                                                <ListItemText>بیمه آتش‌سوزی تملیکی یا درشرف تملیک  - بانک صنعت و معدن</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeFireEmployeehouse}>
                                                                <ListItemIcon><WhatshotTwoToneIcon /></ListItemIcon>
                                                                <ListItemText>بیمه آتش‌سوزی مسکونی کارکنان - بانک صنعت و معدن</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeResbuildmng}>
                                                                <ListItemIcon><WhatshotTwoToneIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت مسئولیت مدیران ساختمان</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeBuildingQuality}>
                                                                <ListItemIcon><ApartmentIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت تضمین کیفیت</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeElevator}>
                                                                <ListItemIcon><MeetingRoomIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت بیمه آسانسور</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeTravel}>
                                                                <ListItemIcon><FlightLandTwoToneIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت بیمه مسافرتی</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeTherapy}>
                                                                <ListItemIcon><AirlineSeatReclineNormalIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت درمان انفرادی و خانواده</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeAccident}>
                                                                <ListItemIcon><AirlineSeatReclineNormalIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت بیمه حوادث</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeCorona}>
                                                                <ListItemIcon><BugReportIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت بیمه کرونا</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeResponsdoctors}>
                                                                <ListItemIcon><LocalHospitalIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت مسئولیت پزشکان</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeCar}>
                                                                <ListItemIcon><DirectionsCarIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت اتوموبیل</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeBossToEmployee}>
                                                                <ListItemIcon><DirectionsCarIcon /></ListItemIcon>
                                                                <ListItemText>مسئولیت کارفرما در مقابل کارگران</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handlechangeResponseSupervisingEngineer}>
                                                                <ListItemIcon><DirectionsCarIcon /></ListItemIcon>
                                                                <ListItemText>مسئولیت مهندس ناظر، طراح و محاسب</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handlechangeResponseABN}>
                                                                <ListItemIcon><DirectionsCarIcon /></ListItemIcon>
                                                                <ListItemText>سازندگان ابنیه</ListItemText>
                                                          </ListItem>
                                                    </List>
                                              </Collapse>
                                              <Divider />

                                              {/* مالی */}
                                              <ListItem button onClick={() => this.handleClick("8")}>
                                                    <ListItemIcon><MonetizationOnIcon /></ListItemIcon>
                                                    <ListItemText primary="مالی" />
                                                    {open8 ? <ExpandLess /> : <ExpandMore />}
                                              </ListItem>
                                              <Collapse in={open8} timeout="auto" unmountOnExit style={{ backgroundColor: "#F6F5F5" }}>
                                                    <List component="div" disablePadding>
                                                          <ListItem button onClick={this.handleChangeRequestFinancialApproval}>
                                                                <ListItemIcon><PaymentIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت تایید مالی درخواست ها</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeRequestFinancialPay}>
                                                                <ListItemIcon><PlaylistAddCheckTwoToneIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت ارسال برای پرداخت مالی</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeRefundUserFinancial}>
                                                                <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت پرداخت درخواست بازگشت وجه</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeReportInstalment}>
                                                                <ListItemIcon><AssignmentTurnedInIcon /></ListItemIcon>
                                                                <ListItemText>وصول تعهد ها</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeReportFinancial}>
                                                                <ListItemIcon><AttachMoneyIcon /></ListItemIcon>
                                                                <ListItemText>گزارشات مالی</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeReportPay}>
                                                                <ListItemIcon><MonetizationOnIcon /></ListItemIcon>
                                                                <ListItemText>پرداخت های درگاه</ListItemText>
                                                          </ListItem>
                                                          <ListItem button onClick={this.handleChangeReportDoc}>
                                                                <ListItemIcon><PlaylistAddCheckIcon /></ListItemIcon>
                                                                <ListItemText>مدیریت تولید و ارسال اسناد مالی</ListItemText>
                                                          </ListItem>
                                                    </List>
                                              </Collapse>
                                              <Divider />

                                              {/* سایر مدیریت ها */}
                                              <ListItem button onClick={this.handleChangeRequestQuestion}>
                                                    <ListItemIcon><StarHalfTwoToneIcon /></ListItemIcon>
                                                    <ListItemText>سوالات نظر سنجی</ListItemText>
                                              </ListItem>
                                              <ListItem button onClick={this.handleChangeSmsManage}>
                                                    <ListItemIcon><TextsmsTwoToneIcon /></ListItemIcon>
                                                    <ListItemText>مدیریت پیامک ها</ListItemText>
                                              </ListItem>
                                              <ListItem button onClick={this.handleChangeParamstep}>
                                                    <ListItemIcon><FormatListNumberedIcon /></ListItemIcon>
                                                    <ListItemText>مدیریت مراحل ورود پارامترها</ListItemText>
                                              </ListItem>
                                              <ListItem button onClick={this.handleChangeMarketer}>
                                                    <ListItemIcon><PeopleOutlineIcon /></ListItemIcon>
                                                    <ListItemText>مدیریت بازاریابان</ListItemText>
                                              </ListItem>
                                              <ListItem button onClick={this.handleChangePartnerRequest}>
                                                    <ListItemIcon><PeopleOutlineIcon /></ListItemIcon>
                                                    <ListItemText>مدیریت درخواست های نماینده توسعه استانی</ListItemText>
                                              </ListItem>
                                              <ListItem button onClick={this.handleChangeReportReferral}>
                                                    <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                    <ListItemText>گزارشات درصد های همکاری فروش</ListItemText>
                                              </ListItem>
                                              <ListItem button onClick={this.handelChangeBankGateWay}>
                                                    <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                    <ListItemText>تنظیمات درگاه پرداخت</ListItemText>
                                              </ListItem>
                                              <ListItem button onClick={this.handelChangeMS_SMSHandler}>
                                                    <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                    <ListItemText>پنل پیامکی</ListItemText>
                                              </ListItem>
                                              <ListItem button onClick={this.handleChangeSmsReceiver}>
                                                    <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                    <ListItemText>مدیریت پیام های دریافتی</ListItemText>
                                              </ListItem>
                                              <ListItem button onClick={this.handleChangeSmsReceiverEngineeringSystem}>
                                                    <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                    <ListItemText>مدیریت پیام های نظام مهندسی</ListItemText>
                                              </ListItem>
                                              {/*<ListItem button onClick={this.handletMarketersPanel}>*/}
                                              {/*      <ListItemIcon><DescriptionIcon /></ListItemIcon>*/}
                                              {/*      <ListItemText>MARKETER PANEL</ListItemText>*/}
                                              {/*</ListItem>*/}
                                              {/*<ListItem button onClick={this.handletIssuanceMarketersPanel}>*/}
                                              {/*      <ListItemIcon><DescriptionIcon /></ListItemIcon>*/}
                                              {/*      <ListItemText>MARKETER PANEL (ISSUANCE)</ListItemText>*/}
                                              {/*</ListItem>*/}
                                              <ListItem button onClick={this.handelContentManager}>
                                                    <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                    <ListItemText>مدیریت محتوا</ListItemText>
                                              </ListItem>
                                              <ListItem button onClick={this.handelContentManager}>
                                                    <ListItemIcon><DescriptionIcon /></ListItemIcon>
                                                    <ListItemText>مدیریت محتوا</ListItemText>
                                              </ListItem>
                                        </List>

                                        </>

                                    )}



                        </Drawer>



                  </div>
            )
      }
}

const mapStateToPropsAppContainer = (state) => {
      return {
            employeeProperty: state.employeeProperty.employeeProperty,
      }
}

export default withStyles(styles)(connect(mapStateToPropsAppContainer)(Hedear))
